import styled from "styled-components";
import { desktop, mobile } from "../../theme";

export const Test = styled("div")({
  background: "#fff",
  marginTop: 40,
  [desktop]: {
    borderRadius: 25,
  },
  [mobile]: {
    marginLeft: -24,
    marginRight: -24,
  },
});
